import { isIsoDate, isoToDateLocal } from '@go-shared/lib/time';
import React from 'react';

import './DefaultedText.scss';

interface DefaultedTextProps {
  val: string | undefined;
  html?: boolean;
  block?: boolean;
  def?: string;
}

export function DefaultedText(props: DefaultedTextProps) {
  const { val, block, html, def } = props;

  let valToUse = val;

  if (isIsoDate(val || '')) {
    valToUse = isoToDateLocal(val!).toLocaleDateString();
  }

  if (!valToUse || valToUse.length === 0) {
    return <span className="text-smoke italic">{def || 'None'}</span>;
  }

  if (block) {
    if (html) {
      return <div className="defaulted-text" dangerouslySetInnerHTML={{ __html: valToUse }}></div>;
    } else {
      return <div>{valToUse}</div>;
    }
  }

  if (html) {
    return <span className="defaulted-text" dangerouslySetInnerHTML={{ __html: valToUse }}></span>;
  }

  return <span>{valToUse}</span>;
}
